import _default from './Reveal';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Reveal/index.js
// module id = 964
// module chunks = 0